import { render, staticRenderFns } from "./answer-correctness-icon.vue?vue&type=template&id=afbb2770"
import script from "./answer-correctness-icon.vue?vue&type=script&lang=js"
export * from "./answer-correctness-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports